import styled, { css } from "styled-components";
import colors from "../../../constants/colors";

const sizes = {
  small: "1.5rem",
  medium: "2.5rem",
  large: "4rem",
};

// Indigo/purple gradient for services - professional and trustworthy
const STOREFRONT_GRADIENT = "linear-gradient(135deg, #6366F1 0%, #4F46E5 100%)";
const STOREFRONT_COLOR = "#6366F1";

export const StorefrontIconWrapper = styled.div<{
  $size: "small" | "medium" | "large";
  $withGlow: boolean;
  $customStyle: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .MuiSvgIcon-root {
    font-size: ${({ $size }) => sizes[$size]};
    transition: all 0.3s ease;

    ${({ $customStyle, $size }) =>
      $customStyle
        ? $size === "small"
          ? css`
              /* Small icons: solid color for better legibility on mobile */
              color: ${STOREFRONT_COLOR};
            `
          : css`
              /* Medium/Large icons: full gradient treatment */
              background: ${STOREFRONT_GRADIENT};
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            `
        : css`
            color: ${colors.BLACK};
          `}

    ${({ $withGlow, $customStyle }) =>
      $withGlow && $customStyle
        ? css`
            filter: drop-shadow(0 2px 8px rgba(99, 102, 241, 0.4));
          `
        : ""}
  }
`;
